"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TreesSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var TreesSVG = function TreesSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29 28h-6v-8.09A5.98 5.98 0 0025.58 9.2a4.5 4.5 0 10-7.16 0A5.98 5.98 0 0021 19.91V28H10v-3.6a5.5 5.5 0 002.12-9.93A3.96 3.96 0 0013 12a4 4 0 00-8 0 3.96 3.96 0 00.88 2.47A5.5 5.5 0 008 24.4V28H3a1 1 0 000 2h26a1 1 0 000-2zm-8-15a1 1 0 012 0v4a1 1 0 01-2 0zM9.04 23h-.08a.96.96 0 01-.96-.96v-4.08a.96.96 0 01.96-.96h.08a.96.96 0 01.96.96v4.08a.96.96 0 01-.96.96z"
  }));
};
exports.TreesSVG = TreesSVG;
TreesSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TreesSVG);
exports.default = _default;